import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '@env/environment';
import { Franco } from "./franco";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FrancoService {
  private baseUrl: string = environment.baseApiUrl;

  constructor(private http: HttpClient) {}

  public getCommonFranco(francoInput: any): Observable<Franco> {
    console.log('Franco Input:', francoInput);
    return this.http.post<Franco>(`${this.baseUrl}/Franco/GetCommonFranco/`, francoInput).pipe(
      catchError((error) => {
        console.error('Error fetching common franco:', error);
        return of(null);
      })
    );
  }
}
